import {http} from '@/services/http.js'
import {appVersion} from '@/constants/app.js'
import {useEnv} from '@/composables/use-env.js'
import {usePolling} from '@/composables/use-polling.js'
import {ref} from 'vue'

/**
 * Version check composable
 */
export function useVersionCheck() {

  //Local version
  const {gitHash} = useEnv()
  const hasNewVersion = ref(false)

  //Check version
  const checkVersion = async () => {
    try {
      const {origin} = window.location
      const data = await http.request(`${origin}/version.json`, {
        headers: {
          'X-App-Version': appVersion,
          'X-App-Git-Hash': gitHash.value,
        },
        cache: 'no-store',
      })
      if (data?.version && data.version !== gitHash.value) {
        console.warn(`⚠️ Version mismatch\n  - Local version: ${gitHash.value}\n  - Available version: ${data.version} (${data.date})`)
        hasNewVersion.value = true
        stopVersionCheck()
      }
    }
    catch (error) {
      console.warn(`⚠️ Error checking version: ${error.message}`)
    }
  }

  //Check version every minute (with an immediate first check)
  const {start, stop: stopVersionCheck} = usePolling(checkVersion, {interval: 60000})
  const startVersionCheck = () => {
    checkVersion()
    start()
  }

  //Expose interface
  return {
    startVersionCheck,
    stopVersionCheck,
    hasNewVersion,
  }
}
